module.exports = __webpack_public_path__ + "static/img/editar_noticia_page.39a108f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/editar_noticia_page.jpg
// module id = voF8
// module chunks = 1